// extracted by mini-css-extract-plugin
export default {"chat_usuario":"ChatUsuario_chat_usuario__t3raH"};